export const formatAbbreviatedValue = (value: number): string => {
  const isNegative = value < 0
  const absoluteValue = Math.abs(value)
  let formattedValue = ''

  if (absoluteValue >= 1000000000) {
    const billions = absoluteValue / 1000000000
    formattedValue = `${billions % 1 === 0 ? billions : billions.toFixed(1)}B`
  } else if (absoluteValue >= 1000000) {
    const millions = absoluteValue / 1000000
    formattedValue = `${millions % 1 === 0 ? millions : millions.toFixed(1)}M`
  } else if (absoluteValue >= 1000) {
    const thousands = absoluteValue / 1000
    formattedValue = `${thousands % 1 === 0 ? thousands : thousands.toFixed(1)}K`
  } else {
    formattedValue = absoluteValue.toString()
  }

  return isNegative ? `-${formattedValue}` : formattedValue
}
